import { CSSProperties, memo } from 'react'
import { SiteLogoSC, SiteLogoSCProps } from './styled'
import { getAuthData } from 'utils/auth'
import { canUseRebrand, SITE_LOGO_LEGACY, SITE_LOGO_REBRAND } from 'utils/rebrandAccess'

export interface SiteLogoProps extends SiteLogoSCProps {
  className?: string
  style?: CSSProperties
}

function SiteLogo({ className, style }: SiteLogoProps) {
  // Avoid importing AuthDataContext (cycle with pages → layout → SiteLogo).
  // Layout re-mounts after login so JWT/auth is current.
  const authId = getAuthData()?.id
  const guest = authId === undefined || authId === null || authId === ''
  const rebrand = guest || canUseRebrand(authId)
  const src = rebrand ? SITE_LOGO_REBRAND : SITE_LOGO_LEGACY
  return (
    <SiteLogoSC
      className={['site-logo', className].filter(Boolean).join(' ')}
      style={style}
      src={src}
      alt={rebrand ? 'Reflekt Me' : 'site logo'}
    />
  )
}

export default memo(SiteLogo)
